import React from "react";
import {Allow, policyEvents} from "../../../Components/Authorize";
import {ButtonIconDelete, ButtonIconEdit, ButtonIconProgress} from "../../../Components/Inputs/Buttons/ButtonIcon/ButtonIcon";
import {locations} from "../../../Utilities/Location";
import {getFormatTextByValue, getOrderStatusTextByValue} from "../orderUtility";
import {ORDER_STATUS} from "../orderConstants";
import {truncateString} from "../../../Utilities/commonUtilities";
import {Order} from "./orderManagement.types";

interface OrderManagementRowProps {
    canManageOrders: boolean;
    handleCancelOrder: (orderId: string) => void;
    handleOpenEditDialog: (event: React.MouseEvent<HTMLElement>, order: Order) => void;
    redirect: (path: string) => void;
    order: Order;
}

export const OrderManagementRow = ({
                                canManageOrders,
                                handleCancelOrder,
                                handleOpenEditDialog,
                                redirect,
                                order
                            }: OrderManagementRowProps) => {

    const handleSubmitProgress = () => {
        redirect(locations.ORDER_PROCESSING.getLink(order.orderId).to);
    };

    const handleCancelOrderClick = (orderId: string) => {
       handleCancelOrder(orderId);
    };

    return (
        <tr id={order.orderId}>
            <td>
                {order.dateCreatedFormatted}
            </td>
            <td>
                {order.needFromFormatted}
            </td>
            <td>
                {order.accessNumber}
            </td>
            <td>
                {order.itemName} - {getFormatTextByValue(order.format)}
                <div>ISBN: {order.isbn}</div>
            </td>
            <td>
                {order.districtName}
            </td>
            <td>
                {order.shelfLocation ? order.shelfLocation : "Not Assigned"}
            </td>
            <td>
                {order.studentName}
            </td>
            <td>
                {getOrderStatusTextByValue(order.orderStatus)}
            </td>
            <td>
                {order.dateOrderSentToVendorFormatted  ? order.dateOrderSentToVendorFormatted  : "Not Sent"}
            </td>
            <td>
                {order.dateOrderReceivedFromVendorFormatted  ? order.dateOrderReceivedFromVendorFormatted  : "Not Received"}
            </td>
            <td>
                {order.poNumber}
            </td>
            <td>
                {truncateString(order.notes ?? "")}
            </td>
            <td className={`align-center`}>
                <Allow policyEvent={policyEvents.MANAGE_ORDER}>
                    <>
                        {
                            canManageOrders &&
                            <ButtonIconEdit
                                inputDescription={`for ${order.itemName}`}
                                onClick={(event) => handleOpenEditDialog(event as React.MouseEvent<HTMLElement>, order)}
                            />
                        }
                        <ButtonIconProgress
                            inputDescription={`for ${order.itemName}`}
                            onClick={handleSubmitProgress}
                        />
                        {
                            handleCancelOrderClick && order.orderStatus < Number(ORDER_STATUS.PartialOrderReceived.id) &&
                            <ButtonIconDelete
                                inputDescription={`for ${order.itemName}`}
                            onClick={() => {handleCancelOrderClick(order.orderId)}}
                            />
                        }
                    </>
                </Allow>
            </td>
        </tr>
    );
};